import { axiosInstance, axiosInstanceConfig } from "./config";

export const signUp_req = async (data) => {
  const user = data;
  const response = await axiosInstance.post("api/v1/signup", {
    user,
  });

  return response?.data;
};

export const signIn_req = async (data) => {
  const user = data;
  const response = await axiosInstance.post("api/v1/login", {
    user,
  });

  return response;
};

export const userConfirmation_req = async (token) => {
  const response = await axiosInstance.get(
    `api/v1/confirmation?confirmation_token=${token}`
  );

  return response;
};

export const currentUser_req = async () => {
  const response = await axiosInstanceConfig.get(`api/v1/current_user`);

  return response?.data;
};

export const deleteUser_req = async () => {
  const response = await axiosInstanceConfig.detele(`api/v1/current_user`);

  return response;
};
export const changePasswordProfile_Req = async (data) => {
  const user = {
    password: data?.password,
    current_password: data?.current_password,
    password_confirmation: data?.password_confirmation,
  };

  const response = await axiosInstanceConfig.patch(`api/v1/signup`, {
    user,
  });

  return response?.data;
};

export const changeUsername_req = async (username) => {
  const user = {
    username,
  };

  const response = await axiosInstanceConfig.patch(`api/v1/signup`, {
    user,
  });

  return response?.data;
};
